export default __webpack_public_path__ + "static/media/8.7aca9636.jpeg";